module.exports = __webpack_public_path__ + "static/media/ttk.4b661373.png";